import React from "react";

type Props = {
  title: string;
  children: React.ReactNode;
};

export const PanelContainer = ({ title, children }: Props) => (
  <div className="border rounded-md bg-white py-2 h-full overflow-hidden">
    <div className="font-medium text-xs tracking-wider text-gray+2 my-1.5 mx-4">
      {title}
    </div>
    {children}
  </div>
);
